import Vue from "vue"
import App from "./App.vue"
import "../src/assets/css/normalize.css"
import "amfe-flexible"
import VeLine from "v-charts-v2/lib/line"
import VeMap from "v-charts/lib/map.common"
import router from "./router"
// import api from "@/api/interfaceMap";
import Vant from 'vant';
import 'vant/lib/index.css';
import Tabbar from '../src/components/Tabber/index.vue'
import md5 from 'js-md5'
import { dispatchEventStroage, isWeiXin } from '@/utils/tools'
// Vue.use(Tools)
// 为了解决setItemEvent不立即生效，使用事件派发强制更高
dispatchEventStroage()
Vue.prototype.$md5 = md5
Vue.component('Tabbar', Tabbar)
Vue.component(VeLine.name, VeLine)
Vue.component(VeMap.name, VeMap)
Vue.use(Vant)

Vue.config.productionTip = false
Vue.prototype.isWeiXin = isWeiXin()

new Vue({
  router,
  render: h => h(App)
}).$mount("#app")
